import React from 'react'
import styles from './ContainerColumn.module.css'

export function ContainerColumn ({ children }) {
  return <div className={styles.root}>{children}</div>
}
